import logo from '../logo.jpg';
import { useEffect, type CSSProperties } from 'react';
import background from '../background.jpg';
import showRing from '../491916401_10237633934087124_6734949950341830977_n.jpg';
import champion from '../492510160_10237660243424841_2727363524705879726_n.jpg';
import portrait from '../493708346_10237671520866770_4903151623244839737_n.jpg';
import kennel from '../494461965_10237729526356871_9044635333299396249_n.jpg';
import stance from '../504998239_10163370349066162_5749237193908489490_n.jpg';
import closeup from '../505590478_10163370349151162_7432155034492280479_n.jpg';

const gallery = [
  { src: showRing, label: 'Presencia de pista', tone: 'Competencia kennel', tag: 'Show' },
  { src: champion, label: 'Temple sereno', tone: 'Equilibrio y potencia', tag: 'FCI' },
  { src: portrait, label: 'Mirada noble', tone: 'Carácter familiar', tag: 'Raza' },
  { src: kennel, label: 'Línea robusta', tone: 'Estructura atlética', tag: 'Selección' },
  { src: stance, label: 'Orgullo Aukan', tone: 'Tradición y cuidado', tag: 'Crianza' },
  { src: closeup, label: 'Detalle de raza', tone: 'Fuerza con calma', tag: 'Carácter' },
];

const traits = ['Lealtad', 'Dignidad', 'Coraje', 'Calma alerta'];

const stats = [
  { value: '01', label: 'Criadero familiar' },
  { value: 'AKC', label: 'Tipo Akita Americano' },
  { value: 'FCI', label: 'Experiencia en pista' },
];

const principles = [
  'Temperamento estable',
  'Socialización temprana',
  'Estructura funcional',
  'Acompañamiento familiar',
];

function App() {
  useEffect(() => {
    const root = document.documentElement;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    if (reduceMotion.matches) {
      return;
    }

    let scrollY = window.scrollY;
    let mouseX = 0;
    let mouseY = 0;
    let frame = 0;

    const updateParallax = () => {
      frame = 0;
      root.style.setProperty('--parallax-far', `${scrollY * -0.035}px`);
      root.style.setProperty('--parallax-mid', `${scrollY * -0.065}px`);
      root.style.setProperty('--parallax-near', `${scrollY * -0.095}px`);
      root.style.setProperty('--parallax-sun', `${scrollY * -0.12}px`);
      root.style.setProperty('--parallax-card', `${scrollY * -0.045}px`);
      root.style.setProperty('--parallax-copy', `${scrollY * -0.012}px`);
      root.style.setProperty('--parallax-ground', `${scrollY * 0.02}px`);
      root.style.setProperty('--parallax-section', `${scrollY * -0.018}px`);
      root.style.setProperty('--mouse-x', `${mouseX * 18}px`);
      root.style.setProperty('--mouse-y', `${mouseY * 14}px`);
      root.style.setProperty('--mouse-x-soft', `${mouseX * 7}px`);
      root.style.setProperty('--mouse-y-soft', `${mouseY * 6}px`);
      root.style.setProperty('--mouse-x-deep', `${mouseX * 24}px`);
      root.style.setProperty('--mouse-y-deep', `${mouseY * 20}px`);
      root.style.setProperty('--mouse-x-reverse', `${mouseX * -18}px`);
      root.style.setProperty('--mouse-card-x', `${mouseX * -10}px`);
      root.style.setProperty('--mouse-card-y', `${mouseY * -8}px`);
    };

    const requestUpdate = () => {
      if (!frame) {
        frame = window.requestAnimationFrame(updateParallax);
      }
    };

    const handleScroll = () => {
      scrollY = window.scrollY;
      requestUpdate();
    };

    const handlePointerMove = (event: PointerEvent) => {
      mouseX = event.clientX / window.innerWidth - 0.5;
      mouseY = event.clientY / window.innerHeight - 0.5;
      requestUpdate();
    };

    updateParallax();
    window.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('pointermove', handlePointerMove, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('pointermove', handlePointerMove);
      if (frame) {
        window.cancelAnimationFrame(frame);
      }
    };
  }, []);

  return (
    <main>
      <section className="hero" id="inicio">
        <div className="lowpoly" aria-hidden="true">
          <div className="sun-orb" />
          <svg className="diorama-scene" viewBox="0 0 900 620" role="img">
            <defs>
              <linearGradient id="baseTop" x1="150" x2="760" y1="350" y2="520">
                <stop offset="0" stopColor="#fff5df" />
                <stop offset="0.52" stopColor="#f7dfad" />
                <stop offset="1" stopColor="#c9a56f" />
              </linearGradient>
              <linearGradient id="baseSide" x1="180" x2="720" y1="500" y2="620">
                <stop offset="0" stopColor="#9a7b4f" />
                <stop offset="1" stopColor="#5f4b37" />
              </linearGradient>
              <linearGradient id="waterGradient" x1="210" x2="730" y1="350" y2="500">
                <stop offset="0" stopColor="#a7d6df" />
                <stop offset="0.55" stopColor="#10a99f" />
                <stop offset="1" stopColor="#087d86" />
              </linearGradient>
              <linearGradient id="goldSlope" x1="260" x2="600" y1="120" y2="410">
                <stop offset="0" stopColor="#ffe7a9" />
                <stop offset="0.55" stopColor="#9b8064" />
                <stop offset="1" stopColor="#473b34" />
              </linearGradient>
              <linearGradient id="tealSlope" x1="300" x2="720" y1="140" y2="470">
                <stop offset="0" stopColor="#a7d6df" />
                <stop offset="0.5" stopColor="#577f82" />
                <stop offset="1" stopColor="#172936" />
              </linearGradient>
              <filter id="softShadow" x="-20%" y="-20%" width="140%" height="150%">
                <feDropShadow dx="0" dy="28" stdDeviation="22" floodColor="#02070c" floodOpacity="0.42" />
              </filter>
            </defs>

            <g filter="url(#softShadow)">
              <ellipse className="diorama-shadow" cx="456" cy="548" rx="360" ry="54" />
              <path className="base-side" d="M92 445c26 91 170 143 363 145 208 2 360-55 384-147v43c-21 90-174 147-384 145-195-2-338-55-363-145z" />
              <ellipse className="base-top" cx="456" cy="438" rx="368" ry="150" />

              <path className="water" d="M212 429c62-62 132-28 181-58 47-29 69-90 142-79 52 8 55 56 104 69 45 12 94-7 128 35 40 51-24 97-94 107-64 9-122-12-181 11-79 31-209 55-284 2-40-28-35-62 4-88z" />
              <path className="water-line" d="M271 446c88 22 119-28 177-38 65-11 107 35 174 29" />
              <path className="water-line" d="M350 499c72-14 106-48 176-35 44 8 69 4 108-11" />
              <path className="water-line" d="M235 482c38 31 88 33 143 20" />

              <g className="mountain-cluster">
                <g className="mountain main">
                  <polygon className="facet light" points="473,62 392,326 516,353" />
                  <polygon className="facet mid" points="473,62 516,353 654,356" />
                  <polygon className="facet dark" points="473,62 654,356 560,214" />
                  <polygon className="facet warm" points="392,326 331,415 516,353" />
                  <polygon className="facet teal" points="516,353 631,436 654,356" />
                  <polygon className="snow" points="473,62 431,157 463,139 490,182 517,131" />
                </g>

                <g className="mountain left">
                  <polygon className="facet light" points="321,156 238,385 363,367" />
                  <polygon className="facet mid" points="321,156 363,367 466,354" />
                  <polygon className="facet dark" points="321,156 466,354 405,246" />
                  <polygon className="snow" points="321,156 282,235 318,218 340,257 363,212" />
                </g>

                <g className="mountain right">
                  <polygon className="facet light" points="658,202 579,403 699,378" />
                  <polygon className="facet mid" points="658,202 699,378 778,421" />
                  <polygon className="facet dark" points="658,202 778,421 730,303" />
                  <polygon className="snow" points="658,202 623,272 657,257 683,288 698,244" />
                </g>

                <g className="mountain front">
                  <polygon className="facet light" points="430,273 363,456 472,436" />
                  <polygon className="facet mid" points="430,273 472,436 554,465" />
                  <polygon className="facet dark" points="430,273 554,465 514,346" />
                  <polygon className="snow" points="430,273 400,331 430,319 450,346 467,310" />
                </g>
              </g>

              <path className="waterfall" d="M351 260c35 44-2 112-44 151" />
              <path className="waterfall-glow" d="M360 267c16 39-9 86-41 126" />

              <g className="rocks">
                <ellipse cx="531" cy="508" rx="32" ry="18" />
                <ellipse cx="622" cy="492" rx="24" ry="15" />
                <ellipse cx="292" cy="514" rx="22" ry="12" />
                <ellipse cx="705" cy="449" rx="25" ry="14" />
              </g>

              <g className="trees">
                <g transform="translate(178 395) scale(1.1)">
                  <rect x="18" y="34" width="10" height="34" rx="3" />
                  <circle cx="23" cy="28" r="24" />
                  <circle cx="5" cy="38" r="15" />
                  <circle cx="42" cy="39" r="17" />
                </g>
                <g transform="translate(669 343) scale(.95)">
                  <rect x="18" y="34" width="10" height="34" rx="3" />
                  <circle cx="23" cy="28" r="24" />
                  <circle cx="5" cy="38" r="15" />
                  <circle cx="42" cy="39" r="17" />
                </g>
                <g transform="translate(726 388) scale(.72)">
                  <rect x="18" y="34" width="10" height="34" rx="3" />
                  <circle cx="23" cy="28" r="24" />
                  <circle cx="5" cy="38" r="15" />
                  <circle cx="42" cy="39" r="17" />
                </g>
                <g transform="translate(402 474) scale(.62)">
                  <rect x="18" y="34" width="10" height="34" rx="3" />
                  <circle cx="23" cy="28" r="24" />
                  <circle cx="5" cy="38" r="15" />
                  <circle cx="42" cy="39" r="17" />
                </g>
              </g>
            </g>
          </svg>
        </div>

        <nav className="nav" aria-label="Navegación principal">
          <a className="brand" href="#inicio" aria-label="Aukan Canai inicio">
            <img src={logo} alt="Logo Aukan Canai" />
            <span>Aukan Canai</span>
          </a>
          <div className="nav-links">
            <a href="#historia">Historia</a>
            <a href="#ejemplares">Ejemplares</a>
            <a href="#crianza">Crianza</a>
          </div>
        </nav>

        <div className="hero-grid">
          <div className="hero-copy">
            <div className="markline">
              <span>Selección responsable</span>
            </div>
            <p className="eyebrow">Criadero familiar · Akita Americano</p>
            <h1>Fuerza ancestral, corazón de casa.</h1>
            <p className="lead">
              En Aukan Canai celebramos al Akita Americano como compañero
              noble: guardián sereno, atleta imponente y presencia familiar que
              se gana el respeto sin levantar la voz.
            </p>
            <div className="actions">
              <a className="button primary" href="#ejemplares">
                Ver ejemplares
              </a>
              <a className="button ghost" href="#historia">
                Conocer la raza
              </a>
            </div>
            <dl className="stats" aria-label="Credenciales del criadero">
              {stats.map((item) => (
                <div key={item.label}>
                  <dt>{item.value}</dt>
                  <dd>{item.label}</dd>
                </div>
              ))}
            </dl>
          </div>

          <aside className="hero-card">
            <img src={background} alt="Paisaje ilustrado de Aukan Canai" />
            <div className="hero-card-content">
              <span>Criadero Aukan Canai</span>
              <strong>Akita Americano con carácter, estructura y nobleza.</strong>
              <small>Selección familiar enfocada en temperamento estable, presencia equilibrada y respeto por la esencia de la raza.</small>
            </div>
          </aside>
        </div>
      </section>

      <section className="story section" id="historia">
        <div className="section-heading">
          <p className="eyebrow">Historia y anécdotas</p>
          <h2>Una raza nacida entre nieve, lealtad y carácter.</h2>
        </div>
        <div className="story-grid">
          <article className="glass">
            <h3>De Japón al mundo</h3>
            <p>
              El Akita tiene raíces en perros de montaña japoneses, criados por
              su resistencia y valentía. Con el tiempo, algunas líneas
              evolucionaron hacia el Akita Americano: más grande, poderoso y con
              una expresión contundente, pero conservando esa dignidad silenciosa
              que lo hizo legendario.
            </p>
          </article>
          <article className="glass accent">
            <h3>La anécdota que siempre vuelve</h3>
            <p>
              Quien convive con un Akita aprende rápido una pequeña verdad: no
              obedecen por ruido, obedecen por vínculo. Primero observan, luego
              deciden confiar. Esa mezcla de independencia y devoción es parte de
              su encanto —y también de la responsabilidad de criarlos bien.
            </p>
          </article>
          <article className="glass">
            <h3>Carácter de guardián</h3>
            <p>
              Su presencia impresiona, pero su mejor virtud es la templanza. Un
              buen Akita Americano debe sentirse seguro, socializado y guiado con
              respeto: firmeza amable, rutina clara y una familia que entienda su
              nobleza.
            </p>
          </article>
        </div>
      </section>

      <section className="traits">
        {traits.map((trait) => (
          <span key={trait}>{trait}</span>
        ))}
      </section>

      <section className="section gallery-section" id="ejemplares">
        <div className="gallery-heading">
          <div className="section-heading compact">
            <p className="eyebrow">Ejemplares y competencias</p>
            <h2>Presencia, estructura y temperamento en una sola mirada.</h2>
          </div>
          <p>
            Una selección visual de pista y crianza: perros con hueso, balance,
            expresión segura y ese silencio poderoso que define al Akita.
          </p>
        </div>
        <div className="gallery">
          {gallery.map((item, index) => (
            <figure className="gallery-card" key={item.src} style={{ '--delay': `${index * 80}ms` } as CSSProperties}>
              <img src={item.src} alt={`${item.label} - ${item.tone}`} />
              <figcaption>
                <em>{item.tag}</em>
                <strong>{item.label}</strong>
                <span>{item.tone}</span>
              </figcaption>
            </figure>
          ))}
        </div>
      </section>

      <section className="section care" id="crianza">
        <div className="care-panel">
          <p className="eyebrow">Nuestra crianza</p>
          <h2>Selección responsable, socialización temprana y amor por la raza.</h2>
          <p>
            Aukan Canai proyecta una crianza enfocada en salud, estabilidad y
            carácter. Cada camada merece tiempo, criterio y respeto por el
            estándar, sin olvidar lo esencial: formar perros capaces de vivir
            con familias reales, rutinas reales y vínculos duraderos.
          </p>
          <ul className="principles">
            {principles.map((principle) => (
              <li key={principle}>{principle}</li>
            ))}
          </ul>
          <a className="button primary" href="mailto:contacto@aukancanai.cl">
            Contactar al criadero
          </a>
        </div>
      </section>

      <footer>
        <img src={logo} alt="" aria-hidden="true" />
        <span>Aukan Canai · Akita Americano</span>
        <small>© 2026 Aukan Canai. All rights reserved.</small>
      </footer>
    </main>
  );
}

export default App;
